import { Link, useNavigate } from "react-router-dom";
import ErrorComponent from "../../components/ErrorComponent";
import Loading from "../../components/LoadingComponent";
// import useFetchBlogPosts from "../../custom_hook/useFetchBlogPosts";
import AdminNavBar from "./AdminNavBar";
import { useEffect, useMemo, useState } from "react";
import BlogPost from "../../interface/BlogPostInterface";
import FetchError, { fetchErrorMessage } from "../../interface/FetchError";
import { AxiosResponse } from "axios";
import apiService from "../../services/api.service";
import { useAuth } from "../../contexts/AuthContext";

const AdminBlogPostList = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [error, setError] = useState<FetchError>(null);
  const { user } = useAuth();
  const [isLoading, setLoading] = useState(false);

  // fetch blog posts from API
  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      if (!user?.id) {
        return <Loading />;
      }
      try {
        const postResponse = await apiService.get<AxiosResponse>(
          `/blogposts/?author=${user.id}`
        );
        setPosts(postResponse.data);
      } catch (err) {
        if (err instanceof Error) {
          console.error(`${fetchErrorMessage("", "blog posts")}: ${err}`);
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [user?.id]); // re run if user id becomes avaibable

  // breadcrumb navigation to go back to site materials
  const navigate = useNavigate();
  const handleBackToSiteMaterial = () => {
    navigate("/admin/dashboard/", { state: { from: "blogposts" } });
  };

  const [searchQuery, setSearchQuery] = useState("");
  const filteredPosts = useMemo(() => {
    if (!searchQuery) return posts;
    return posts.filter((post) =>
      post.title.toLowerCase().startsWith(searchQuery.toLowerCase())
    );
  }, [posts, searchQuery]);

  const handleEditButton = (postId: string) => {
    navigate(`/admin/site-materials/blogposts/edit/${postId}`);
  };

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorComponent message={error.message} />;
  }
  return (
    <>
      <nav className="navbar navbar-dark bg-dark">
        <AdminNavBar />
      </nav>
      <nav id="bc-nav" aria-label="breadcrumb">
        <ol id="bc-ol" className="breadcrumb">
          <li id="bc-books" className="breadcrumb-item">
            <button
              className="inactive-anchor-link"
              onClick={handleBackToSiteMaterial}
            >
              Site Materials
            </button>{" "}
            <span className="greater-than">&#x02AA2;</span>
          </li>
          <li id="bc-active" className="breadcrumb-item active">
            Blogposts
          </li>
        </ol>
      </nav>
      <div className="search-add-container">
        <form className="d-flex" role="search">
          <input
            className="form-control me-2"
            type="search"
            placeholder="Search Blogposts"
            aria-label="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>
        <Link
          to={`/admin/site-materials/blogposts/create`}
          className="btn error-page-btn"
        >
          &#43; Add Blogpost
        </Link>
      </div>
      <ul className="list-group bg-dark">
        {filteredPosts.map((post) => (
          <li
            key={post.id}
            id="post-list-row"
            className="d-flex align-items-center"
          >
            <Link
              id="post-list-link"
              className="anchor-link p-2 flex-grow-1 d-flex"
              to={`/admin/site-materials/blogposts/${post.id}`}
            >
              <span className="p-2 flex-fill">{post.title}</span>
              <span id="book-edition-cell" className="p-2 flex-fill">
                Category&#58; {post.category}
              </span>
              <span className="p-2 flex-fill">Author&#58; {post.author}</span>
            </Link>
            <button
              id="edit-post-btn"
              className="btn error-page-btn p-2"
              onClick={() => handleEditButton(post.id.toString())}
            >
              Edit
            </button>
          </li>
        ))}
      </ul>
    </>
  );
};

export default AdminBlogPostList;
